import { environment } from './../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from './../_service/service.service';
import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';

const API_URL=environment.serviceUrl;

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css']
})
export class InformationComponent implements OnInit {
  list:[]
  newsId:any
  id: any;
  picpath:any;

  news={
    newsTitle:String,
    newsDate:String,
    newsCat:String,
    photo:String,
    newsContent:String
  }

  private sub: any;
  constructor(private service:ServiceService,private route:ActivatedRoute,private titleService:Title) { 
    this.id = this.route.snapshot.params.id;
    console.log(this.id);
  }

  ngOnInit(): void {
    this.picpath=API_URL;
    this.id = this.route.snapshot.params.id;
    console.log(this.id);

    let param={
      newsId:this.id
    }
    this.service.qNews(param).subscribe(data=>{
      if(data.result){
        this.news=data.data;
        this.titleService.setTitle(this.news.newsTitle.toString()+"－原碼札記");
        console.log(this.news);
      }
    });
    
  }

}
